import React from "react";
import { Card, Col, Row } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import { useSelector } from "react-redux";

export default function CourtMarket({court, skipCommission = false, hidePrice = false}) {
    const { t } = useTranslation()
    const { commission } = useSelector(state => state.commissions)
    const clubUrl = court?.site?.club?.url || court?.club?.url
    const clubName = court?.site?.club?.name || court?.club?.name || court?.site?.name || ''
    const availableSports = [...new Set([
        ...(Array.isArray(court?.sports) ? court.sports : []),
        ...(Array.isArray(court?.site?.sports) ? court.site.sports : []),
    ].filter(Boolean))]

    const backCardImage = {
        backgroundImage: court?.image ? `url(${court?.image})` : court?.sports?.length > 0 ? `url("/images/sports/${court?.sports[0]}.jpg")` : `url("/images/sports/other_sports.jpg")`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
    }

    const calculatePrice = (price) => {
        if (typeof price !== 'number') {
            price = parseFloat(price)
        }

        if (!isNaN(price) && price > 0) {
            const sitesCommission = skipCommission
                ? null
                : commission?.sites?.find(site => price >= site.lowPrice && price <= site.highPrice)
            return parseFloat((Math.ceil((parseFloat(price) + parseFloat(price * (sitesCommission?.percentage || 0) / 100) + parseFloat(sitesCommission?.double || 0)) * 100) / 100).toFixed(2))
        } else {
            return 0.00
        }
    }

    return (
        <Card className="miniatura">
            <Link to={`/${t("url.marketplace.clubs")}/${clubUrl}/${t("url.marketplace.courts")}/${court?.url}`}>
                <div className="image" variant="top" style={backCardImage}></div>
            </Link>
            <Card.Body>
                <Card.Title className="miniatura-title">{court.name}</Card.Title>
                <Row className="mt-3">
                    <Col className="d-flex align-items-center miniatura-meta-primary">
                        <img src="/images/club.svg" alt="club" className="me-2"/>
                        {clubName}
                    </Col>
                </Row>
                {availableSports.length > 0 && (
                    <Row className="mt-2">
                        <Col className="d-flex align-items-center">
                            <img src={`/images/sports/iconos/${availableSports[0]}.svg`} alt={t("marketplace.sport")} className="me-2"/>
                            {availableSports
                                .map(sport => {
                                    const translatedSport = t('sports.' + sport)
                                    return translatedSport === `sports.${sport}` ? sport : translatedSport
                                })
                                .join(', ')}
                        </Col>
                    </Row>
                )}
                <Row className="mt-4">
                    <Col className={`d-flex align-items-center flex-wrap ${hidePrice ? 'justify-content-end' : 'justify-content-between'}`}>
                        {!hidePrice && (
                            <span className="price">
                                {`${t("global.from")} ${calculatePrice(court?.minPrice)}€`}
                            </span>
                        )}
                        <Link
                            to={`/${t("url.marketplace.clubs")}/${clubUrl}/${t("url.marketplace.courts")}/${court?.url}`}
                            className="btn btn-primary"
                        >
                            {t("courts.reserve")}
                            <img src="/images/rignt-arrow.svg" alt={t("courts.reserve")} className="ms-3"/>
                        </Link>
                    </Col>
                </Row>
            </Card.Body>
        </Card>
    )
}